<template>
    <div>
        <money :id="`div_`+name"
               v-model="value"
               v-bind="money"
               :maxlength="maxLength"
               :name="`div_`+name"
               class="form-control">
        </money>

        <input :id="name" v-model="value" :name="name" type="hidden">
    </div>
</template>

<script>
import {Money} from 'v-money';

export default {
    name: "FloatMaskComponent",
    components: {Money},
    props: {
        initialValue: {
            type: Number,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        maxLength: {
            type: Number,
            required: false,
            default: 8
        },
    },
    data() {
        return {
            value: 0,
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },
    mounted() {

        this.value = this.initialValue;
    },
}
</script>

<style scoped>

</style>
